import attributionPostbacksImageSrc from '../resources/png/teamManagement/attribution_postbacks.png';
import attributionWindowSettingsImageSrc from '../resources/png/teamManagement/attribution_window_settings.png';
import configurationCredentialsImageSrc from '../resources/png/teamManagement/configuration_credentials.png';
import eventPostbacksImageSrc from '../resources/png/teamManagement/event_postbacks.png';
import linkAttributionSettingsImageSrc from '../resources/png/teamManagement/link_attribution_settings.png';
import linkOgTagsImageSrc from '../resources/png/teamManagement/link_og_tags.png';
import linkParametersImageSrc from '../resources/png/teamManagement/link_parameters.png';
import linkSettingsAndRedirectsImageSrc from '../resources/png/teamManagement/link_settings_and_redirects.png';
import { SECTIONS } from '../utils/consts';
import { MANAGE_PERMISSIONS_STEPS, translationPrefix as translationRootPrefix } from './utils';

const translationPrefix = `${translationRootPrefix}.MANAGE_PERMISSIONS_PAGE`;

// Preload images
[
    configurationCredentialsImageSrc,
    attributionPostbacksImageSrc,
    attributionWindowSettingsImageSrc,
    eventPostbacksImageSrc,
    linkSettingsAndRedirectsImageSrc,
    linkParametersImageSrc,
    linkAttributionSettingsImageSrc,
    linkOgTagsImageSrc,
].forEach(src => {
    const img = new Image();
    img.src = src;
});

export const SECTIONS_PAGES_CONFIG = [
    {
        step: MANAGE_PERMISSIONS_STEPS.attribution,
        page: {
            link: 'react/partner-config',
            translationKey: `${translationPrefix}.ATTRIBUTION.PAGE_DISPLAY_NAME`,
        },
        cards: [
            {
                title: `${translationPrefix}.ATTRIBUTION.TITLE`,
                description: `${translationPrefix}.ATTRIBUTION.DESCRIPTION`,
                parts: [
                    {
                        sectionNames: [SECTIONS.PARTNER_CONFIGURATION_CREDENTIALS],
                        tooltipImageSrc: configurationCredentialsImageSrc,
                        tooltipDescriptionSectionName: SECTIONS.PARTNER_CONFIGURATION_CREDENTIALS,
                    },
                    {
                        displayName: `${translationPrefix}.ATTRIBUTION.ATTRIBUTION_POSTBACKS.DISPLAY_NAME`,
                        sectionNames: [
                            SECTIONS.PARTNER_CONFIGURATION_ATTRIBUTION_INSTALL_POSTBACKS,
                            SECTIONS.PARTNER_CONFIGURATION_ATTRIBUTION_REENGAGEMENT_POSTBACKS,
                        ],
                        tooltipImageSrc: attributionPostbacksImageSrc,
                    },
                    {
                        sectionNames: [SECTIONS.PARTNER_CONFIGURATION_ATTRIBUTION_WINDOW_SETTINGS],
                        tooltipImageSrc: attributionWindowSettingsImageSrc,
                    },
                    {
                        sectionNames: [SECTIONS.PARTNER_CONFIGURATION_IN_APP_EVENTS_POSTBACK],
                        tooltipImageSrc: eventPostbacksImageSrc,
                    },
                ],
            },
        ],
    },
    {
        step: MANAGE_PERMISSIONS_STEPS.links,
        page: {
            link: 'react/link-management',
            translationKey: `${translationPrefix}.LINKS.PAGE_DISPLAY_NAME`,
        },
        cards: [
            {
                title: `${translationPrefix}.LINKS.PARTNER_LINKS.TITLE`,
                description: `${translationPrefix}.LINKS.PARTNER_LINKS.DESCRIPTION`,
                parts: [
                    {
                        sectionNames: [SECTIONS.MANAGE_LINKS_PARTNER_LINK_SETTINGS_AND_REDIRECTS],
                        tooltipImageSrc: linkSettingsAndRedirectsImageSrc,
                    },
                    {
                        sectionNames: [SECTIONS.MANAGE_LINKS_PARTNER_ATTRIBUTION_SETTINGS],
                        tooltipImageSrc: linkAttributionSettingsImageSrc,
                    },
                ],
            },
            {
                title: `${translationPrefix}.LINKS.CUSTOM_SOURCE_LINKS.TITLE`,
                description: `${translationPrefix}.LINKS.CUSTOM_SOURCE_LINKS.DESCRIPTION`,
                parts: [
                    {
                        sectionNames: [SECTIONS.MANAGE_LINKS_CUSTOM_LINK_SETTINGS_AND_REDIRECTS],
                        tooltipImageSrc: linkSettingsAndRedirectsImageSrc,
                    },
                    {
                        sectionNames: [SECTIONS.MANAGE_LINKS_CUSTOM_ATTRIBUTION_SETTINGS],
                        tooltipImageSrc: linkAttributionSettingsImageSrc,
                    },
                    {
                        sectionNames: [SECTIONS.MANAGE_LINKS_CUSTOM_OG_TAGS],
                        tooltipImageSrc: linkOgTagsImageSrc,
                    },
                    {
                        sectionNames: [SECTIONS.MANAGE_LINKS_CUSTOM_LINK_PARAMETERS],
                        tooltipImageSrc: linkParametersImageSrc,
                    },
                ],
            },
        ],
    },
];

export const SECTION_PAGES_STEPS = SECTIONS_PAGES_CONFIG.map(({ step }) => step);
